var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("filter-text-input", {
        staticClass: "modpack__filterinput",
        attrs: {
          disabled: !_vm.state.modsReady || _vm.state.modsError,
          placeholder: _vm.state.placeholder,
          nullable: false,
          "filter-items-fn": _vm.filterModsByPhrase,
          data: _vm.state.groupedMods,
          "value-key": "key",
          "label-fn": _vm.labelFunction,
          grouped: true,
          "group-key": "slug",
          "group-items-key": "mods",
          "group-label-fn": _vm.groupLabelFunction,
          "no-entry-title": _vm.noItemsFoundMessage,
          "float-style": _vm.floatStyle,
          "display-background-image": false,
          "is-valid": _vm.isValid,
        },
        on: { change: _vm.modSelected },
        model: {
          value: _vm.state.selectedMod,
          callback: function ($$v) {
            _vm.$set(_vm.state, "selectedMod", $$v)
          },
          expression: "state.selectedMod",
        },
      }),
      _vm._v(" "),
      _vm.state.modsError
        ? _c("p", { staticClass: "mt-4 mb-0" }, [
            _vm._v(
              "\n    " +
                _vm._s(_vm.i18n.t("landingpage:modpack.api_unavailable")) +
                "\n  "
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }